import { render, staticRenderFns } from "./AddToBookListForm.vue?vue&type=template&id=bdade2a0&scoped=true&"
import script from "./AddToBookListForm.vue?vue&type=script&lang=js&"
export * from "./AddToBookListForm.vue?vue&type=script&lang=js&"
import style0 from "./AddToBookListForm.vue?vue&type=style&index=0&id=bdade2a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../.yarn/__virtual__/vue-loader-virtual-2f6a8101d6/2/home/apps/.yarn/berry/cache/vue-loader-npm-15.10.1-3a0b6c19d2-10c0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdade2a0",
  null
  
)

export default component.exports